import React from 'react';

interface Props {
  title: string;
}

export const EntityTitle: React.FC<Props> = ({ title }) => (
  <div className="c-title c-title--uppercase c-title--fs-18">{title}</div>
);
